<span class="hover-content flex-text-ellipsis">
  <ng-content/>
</span>

@if (route && route.length) {
  <a class="hover-icon" [routerLink]="route">
    <i class="icon ic-eye ml-2"></i>
  </a>
}
